import type { EmailLogStatus } from '@/api/emailLog/emailLogApi.types';

export const EMAIL_LOG_TAB_QUERY_VALUE = 'emails';

export const ALL_EMAIL_LOG_STATUSES = 'all';

export type EmailLogStatusFilter = EmailLogStatus | typeof ALL_EMAIL_LOG_STATUSES;

export const EMAIL_LOG_STATUS_FILTERS: EmailLogStatusFilter[] = [
  ALL_EMAIL_LOG_STATUSES,
  'sent',
  'failed',
];

export const EMAIL_PREVIEW_FRAME_HEIGHT_PIXELS = 560;
